// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"apps_onboarding_src_app_pages_pages_module_ts":"221fdcd87fc9d42e","node_modules_pnpm_qr-scanner_1_4_2_node_modules_qr-scanner_qr-scanner-worker_min_js":"00031484f40b5ee8"}[chunkId] + ".js";
};